import gql from 'graphql-tag';

export const edit = gql`mutation EditFog($id: ID!, $fog: FogInput!) {
    editFog(id: $id, fog: $fog) {
        id
        archived
        reference
        creationDate
        overageClientRate
        overageUnderwriterRate
        voyageNb
        notes
        overage
        coverType
        rebateRate
        brokerageReturn
        comments
        vat8
        documents {
            id
            creationDate
            type
            url
            accountancyUrl
            basename
            canceled
        }

        client {
            id
            name
        }
        currency {
            id
            symbol
            isoCode
        }

        vessel {
            id
            name
            year
        }

        underwriter {
            id
            name
            rebateRate
        }

        invoices {
            id
            amount
            label
            documentType
        }

        costs {
            id
            invoiceNumber
        }

        cargos {
            value
            quantity
            excessExclusion
            commodity {
                id
                commodityGroup {
                    id
                    name
                }
            }
            
            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
            
            cargoPorts {
                id
                operation
                port {
                    id
                    country {
                        id
                        name
                    }
                }
            }
        }
    }
}`;


export const add = gql`mutation CreateFog($fog: FogInput!) {
    createFog(fog: $fog) {
        id
        archived
        reference
        creationDate
        overageClientRate
        overageUnderwriterRate
        voyageNb
        notes
        overage
        coverType
        rebateRate
        brokerageReturn
        comments
        vat8
        documents {
            id
            creationDate
            type
            url
            accountancyUrl
            basename
            canceled
        }

        client {
            id
            name
        }
        currency {
            id
            symbol
            isoCode
        }

        vessel {
            id
            name
            year
        }

        underwriter {
            id
            name
            rebateRate
        }

        invoices {
            id
            amount
            label
            documentType
        }

        costs {
            id
            invoiceNumber
        }

        cargos {
            value
            quantity
            excessExclusion
            commodity {
                id
                commodityGroup {
                    id
                    name
                }
            }
            
            clientRate {
                id
                name
                creationDate
                client {
                    id
                }
                isMarineOnly
                rate
                franchise
            }
            underwriterRate {
                id
                name
                rate
                company {
                    id
                    name
                }
            }
            
            cargoPorts {
                id
                operation
                port {
                    id
                    country {
                        id
                        name
                    }
                }
            }
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/fog.js